'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isRenderable = exports.getPropType = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _createChainablePropType = require('./createChainablePropType');

var _createChainablePropType2 = _interopRequireDefault(_createChainablePropType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getPropType = exports.getPropType = function getPropType(_ref) {
  var propTypes = _ref.propTypes,
      defaultProps = _ref.defaultProps;

  return (0, _createChainablePropType2.default)(_propTypes2.default.elementType, 'renderProp', {
    propTypes: propTypes,
    defaultProps: defaultProps
  });
};

var isRenderable = exports.isRenderable = function isRenderable(children) {
  return children != null && children !== false;
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3620/js/utils/propTypes/renderProp.js
// module id = 56
// module chunks = 177